import React from 'react';
import { useFormContext } from 'react-hook-form';

const InsuranceSection = () => {
  const { register, formState: { errors }, watch } = useFormContext();
  const insuranceType = watch('insurance.type') || '$100000';

  return (
    <div className="insurance-section">
      <h3 className="form-section-title">Insurance</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="insurance.type">Motor Truck Cargo Coverage</label>
          <select
            id="insurance.type"
            {...register('insurance.type')}
            className={errors.insurance?.type ? 'error' : ''}
          >
            <option value="$100000">$100000</option>
            <option value="$250000">$250000</option>
            <option value="$500000">$500000</option>
            <option value="Custom">Choose another option</option>
          </select>
          {errors.insurance?.type && (
            <span className="error-message">{errors.insurance.type.message}</span>
          )}
        </div>

        {(insuranceType === 'Custom' || insuranceType === 'custom') && (
          <div className="form-group">
            <label htmlFor="insurance.customAmount">Custom Amount ($)</label>
            <input
              type="text"
              id="insurance.customAmount"
              placeholder="Enter amount"
              {...register('insurance.customAmount', {
                required: (insuranceType === 'Custom' || insuranceType === 'custom') ? 'Custom amount is required' : false
              })}
              className={errors.insurance?.customAmount ? 'error' : ''}
            />
            {errors.insurance?.customAmount && (
              <span className="error-message">{errors.insurance.customAmount.message}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InsuranceSection;

